import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useTranslation } from 'react-i18next'
import { getDonutChartOptions } from 'config/highcharts'
import { sortdData } from 'utils/highcharts.utils'

Highcharts.setOptions({
  credits: { enabled: false }
})

const WorkersInBlockChart = ({ data = [], onBlockClick = null }) => {
  const { t } = useTranslation()
  const chartData = data.map(d => ({
    name: d.blockName || t('dashboard.unknownBlock'),
    y: parseInt(d.workerCount || 0),
    max: parseInt(d.workerCount || 0),
    blockData: d
  }))

  const total = chartData.reduce((sum, item) => sum + item.y, 0)

  const chartOptions = getDonutChartOptions({
    data: sortdData(chartData),
    title: t('dashboard.workersCount', { total }),
    useFormatter: true,
    onPointClick: onBlockClick
  })

  return (
    <div className='w-full h-96 min-h-[600px] p-6'>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  )
}

export default WorkersInBlockChart
